module.exports = __webpack_public_path__ + "static/media/a4.87eb3bc5.png";